import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const AddCaseForm = ({ closeModal, onProjectAdded }) => {
  // Use a function to initialize the state from sessionStorage
  const [caseData, setCaseData] = useState(() => {
    // Attempt to get the data from sessionStorage
    const storedCaseData = sessionStorage.getItem("caseFormData");
    // If data exists, parse it and use it, otherwise, use the initial empty object
    return storedCaseData
      ? JSON.parse(storedCaseData)
      : {
          caseTitle: "",
          client: "",
          caseNumber: "",
          caseType: "",
          caseYear: "",
          StartDate: "",
          contactName: "",
          contactEmail: "",
          contactPhone: "",
        };
  });

  const [showBillTo, setShowBillTo] = useState(false);
  const [showContact, setShowContact] = useState(false);
  const [clients, setClients] = useState([]);
  const [caseExists, setCaseExists] = useState(false);
  const [checkingCase, setCheckingCase] = useState(false);

  // Use useEffect to save caseData to sessionStorage whenever it changes
  useEffect(() => {
    sessionStorage.setItem("caseFormData", JSON.stringify(caseData));
  }, [caseData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCaseData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    const fetchClients = async () => {
      const token = localStorage.getItem("token");

      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/client`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        });
        setClients(response.data);
      } catch (error) {
        console.error("Error fetching clients:", error);
      }
    };

    fetchClients();
  }, []);

  const checkCaseNumberExists = async (number) => {
    const token = localStorage.getItem("token");
    setCheckingCase(true);
    try {
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/Projects`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });
      const exists = res.data.some((c) => c.caseNumber === Number(number));
      setCaseExists(exists);
    } catch (err) {
      console.error("Error checking case number:", err);
      setCaseExists(false);
    } finally {
      setCheckingCase(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    if (!caseData.caseNumber || caseData.caseNumber.trim() === "") {
      alert("Project number is required");
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/Projects`,
        caseData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );

      toast.success("Case added successfully!");
      
      // Clear sessionStorage data on successful form submission
      sessionStorage.removeItem("caseFormData");
      
      setCaseData({
        caseTitle: "",
        client: "",
        caseNumber: "",
        caseType: "",
        caseYear: "",
        StartDate: "",
        contactName: "",
        contactEmail: "",
        contactPhone: "",
      });

  
      setShowBillTo(false);
      setShowContact(false);
          // 🔑 THIS IS THE KEY CHANGE
    if (onProjectAdded) {
      onProjectAdded();
    }
      if (closeModal) closeModal();
    } catch (error) {
      console.error("Error adding case:", error.response?.data || error.message);
      if (
        error.response &&
        error.response.data &&
        error.response.data.error === "Case number already exists"
      ) {
        toast.warn("This case number already exists...", { toastId: "duplicate-case" });
      } else {
        toast.error("Failed to add case. Please try again.");
      }
    }
  };


  return (
    <div className="w-full">
      <div className="bg-white rounded-lg shadow-lg p-6">
        <h2 className="text-2xl font-semibold text-center mb-6">
          Add Project To Workspace
        </h2>
        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Case Title & Number */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-1">Project Title</label>
              <input
                type="text"
                name="caseTitle"
                value={caseData.caseTitle}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
                placeholder="Enter project title"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Client</label>

              <select
                name="client"
                value={caseData.client}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              >
                <option value="">Select a Client</option>
                {clients.map((client) => (
                  <option key={client._id} value={client._id}>
                    {client.clientName}
                  </option>
                ))}
              </select>

            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Project Number</label>
              <input
                type="number"
                name="caseNumber"
                value={caseData.caseNumber}
                onChange={(e) => {
                  handleChange(e);
                  setCaseExists(false); // clear the case exists error when user changes the number
                }}
                onBlur={(e) => checkCaseNumberExists(e.target.value)} // Check case number when user leaves the input
                className={`w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 ${caseExists ? "border-red-500 ring-red-300" : "focus:ring-blue-500"}`}
                required
                placeholder="Enter project number"
              />

              {checkingCase && (
                <p className="text-sm text-gray-500 mt-1">Checking Project number...</p>
              )}
              {caseExists && (
                <p className="text-sm text-red-600 mt-1">
                  This Project number already exists. Please use a different number.
                </p>
              )}
            </div>


            <div>
              <label className="block text-sm font-medium mb-1">Project Type</label>
              <select
                name="caseType"
                value={caseData.caseType}
                onChange={handleChange}
                required
                className="w-full border rounded px-3 py-2"
              >
                <option value="">Select Project Type</option>
                <option value="E-commerce">E-commerce</option>
                <option value="Portofolio">Portofolio</option>
                <option value="Bussiness site">Bussiness site</option>
              </select>
            </div>
          </div>

          {/* Case Type & Court Type */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">


            <div>
              <label className="block text-sm font-medium mb-1">Project Year</label>
              <select
                name="caseYear"
                value={caseData.caseYear}
                onChange={handleChange}
                required
                className="w-full border rounded px-3 py-2"
              >
                <option value="">Select Year</option>
                {[...Array(20)].map((_, i) => {
                  const year = new Date().getFullYear() - i;
                  return (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>

          

          {/* Hearing Date */}
          <div>
            <label className="block text-sm font-medium mb-1">Start Date</label>
            <input
              type="date"
              name="StartDate"
              value={caseData.StartDate}
              onChange={handleChange}
              className="w-full border rounded px-3 py-2"
              placeholder="Select start date"
            />
          </div>
          <div className="border rounded p-4 space-y-4 bg-gray-50">
            <h4 className="text-lg font-semibold">Contact</h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

              <div>
                <label className="block text-sm font-medium mb-1">Contact Email</label>
                <input
                  type="email"
                  name="contactEmail"
                  value={caseData.contactEmail}
                  onChange={handleChange}
                  required
                  className="w-full border rounded px-3 py-2"
                  placeholder="Enter contact email"
                />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Contact Phone</label>
              <input
                type="tel"
                name="contactPhone"
                value={caseData.contactPhone}
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow only numbers and limit to 10 digits
                  if (/^\d{0,10}$/.test(value)) {
                    handleChange(e);
                  }
                }}
                required
                pattern="\d{10}"
                inputMode="numeric"
                maxLength={10}
                className="w-full border rounded px-3 py-2"
                placeholder="Enter 10-digit mobile number"
              />
            </div>

          </div>


          <button
            type="submit"
            disabled={checkingCase || caseExists}
            className="w-full bg-green-600 text-white px-4 py-3 rounded hover:bg-green-700"
          >
            Submit Project
          </button>

        </form>
      </div>
    </div>
  );
};

export default AddCaseForm;
